export enum AppendixCardVariant {
  PADDED = "padded",
  FULL = "full",
  ICON = "icon",
}
